module.exports = __webpack_public_path__ + "static/media/data.4c4cc86b.csv";